import { Routes } from '@angular/router'

import { COMPANY_INFO_DATA_TAB_NAME } from '~/core/constants'
import { AuthGuard } from '~/core/guards'
import { ECompanyInfoRoute } from '~/core/models'

import { CompanyInfoComponent } from './company-info.component'
import {
  TAB_COMPARABLE_COMPANIES_LINK,
  TAB_EARN_LINK,
  TAB_EDGAR_REPORT_LINK,
  TAB_FULL_EDGAR_REPORT_LINK,
  TAB_HISTORICAL_DATA_LINK,
  TAB_STOCK_PREDICTIONS_LINK,
} from './constants'
import {
  ComparableCompaniesComponent,
  EarnComponent,
  EdgarReportComponent,
  FullEdgarReportComponent,
  HistoricalDataComponent,
  StockPricePredictionsComponent,
} from './tabs'

export const COMPANY_INFO_ROUTES: Routes = [
  {
    path: '',
    component: CompanyInfoComponent,
    children: [
      {
        path: TAB_EARN_LINK,
        component: EarnComponent,
        data: { [COMPANY_INFO_DATA_TAB_NAME]: ECompanyInfoRoute.EARN },
      },
      {
        path: TAB_STOCK_PREDICTIONS_LINK,
        component: StockPricePredictionsComponent,
        data: { [COMPANY_INFO_DATA_TAB_NAME]: ECompanyInfoRoute.STOCK_PREDICTIONS },
      },
      {
        path: TAB_HISTORICAL_DATA_LINK,
        component: HistoricalDataComponent,
        data: { [COMPANY_INFO_DATA_TAB_NAME]: ECompanyInfoRoute.HISTORICAL_DATA },
      },
      {
        path: TAB_COMPARABLE_COMPANIES_LINK,
        component: ComparableCompaniesComponent,
        data: { [COMPANY_INFO_DATA_TAB_NAME]: ECompanyInfoRoute.COMPARABLE_COMPANIES },
      },
      {
        path: TAB_EDGAR_REPORT_LINK,
        component: EdgarReportComponent,
        data: { [COMPANY_INFO_DATA_TAB_NAME]: ECompanyInfoRoute.EDGAR_REPORT },
      },
      {
        path: TAB_FULL_EDGAR_REPORT_LINK,
        component: FullEdgarReportComponent,
        canActivate: [AuthGuard],
        data: { [COMPANY_INFO_DATA_TAB_NAME]: ECompanyInfoRoute.FULL_EDGAR_REPORT },
      },
      { path: '**', redirectTo: TAB_EARN_LINK },
    ],
  },
]
